import React, { memo } from 'react';

import { Paper } from '../material-ui/Paper';
import { Swiper } from '../Swiper/Swiper';
import { DutyTimePanel } from './DutyTimePanel/DutyTimePanel';
import { MeasurePanel } from './MeasurePanel/MeasurePanel';
import { useBottomFlightBar } from './useBottomFlightBar';
import { useStyles } from './useStyles';

export const BottomFlightBar = memo(() => {
    const { activeSlide, breakpoints, slides } = useBottomFlightBar();
    const classes = useStyles();

    if (!(slides && slides.length > 0)) {
        return null;
    }

    return (
        <Paper className={classes.footer} elevation={0} square>
            <MeasurePanel />
            <Swiper
                className={classes.swiper}
                wraperClassName={classes.wraper}
                slides={slides}
                slidesPerView={1}
                initialSlide={activeSlide}
                breakpoints={breakpoints}
            />
            <DutyTimePanel />
        </Paper>
    );
});

BottomFlightBar.displayName = 'BottomFlightBar';
